import { DealsTable } from '../../../components/Tables/DealsTable/DealsTable'
import React from 'react'
import { StatsCard, StatsContainer } from '../../../styled/Stats'
import { formatInteger } from '../../../utils/formatting'
import { DEAL_TABLE_KEY } from 'constants/tableQueryKeys'
import {
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { FBPage } from '../../../components/FbUI/Page/FBPage'
import { StageColorProvider } from 'components/SalesStage/StageColorContext'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

export function DealsPage() {
  const [totalDeals, setTotalDeals] = React.useState<number>()
  const { dealDetailPage } = useFeatureFlagService()

  const placesStats = [
    {
      name: 'Total Deals',
      value: formatInteger(totalDeals),
      isLoading: totalDeals == null,
    },
  ]

  const defaultColumnVisibility = dealDetailPage
    ? {
        deal: true,
        identifier: false,
        deal_name: false,
        predicted_annual_revenue: false,
        predicted_monthly_revenue: false,
        monthly_revenue_override: false,
        cc_doors_cnt: false,
      }
    : {
        identifier: false,
        predicted_annual_revenue: false,
        predicted_monthly_revenue: false,
        monthly_revenue_override: false,
        cc_doors_cnt: false,
      }

  const tableContent = (
    <DealsTable
      useReports={true}
      tableKey={DEAL_TABLE_KEY}
      defaultColumnVisibility={defaultColumnVisibility}
      showCompanyColumn
      setTotalRowsCount={setTotalDeals}
    />
  )

  return (
    <FBPage>
      <FBPageHeader>
        <FBPageTitleRow>
          <FBPageTitle>Deals</FBPageTitle>
        </FBPageTitleRow>
        <StatsContainer>
          {placesStats.map((stat) => (
            <StatsCard key={stat.name}>
              <h1> {stat.name} </h1>
              {!stat.isLoading ? (
                <span> {stat.value} </span>
              ) : (
                <span style={{ fontSize: 12, fontWeight: 400 }}>
                  Calculating...
                </span>
              )}
            </StatsCard>
          ))}
        </StatsContainer>
      </FBPageHeader>
      <FBPageTableContainer>
        {dealDetailPage ? (
          <StageColorProvider value="pipeline">
            {tableContent}
          </StageColorProvider>
        ) : (
          tableContent
        )}
      </FBPageTableContainer>
    </FBPage>
  )
}
